export default "__VITE_ASSET__BRqM_g08__"